module.exports = __webpack_public_path__ + "static/img/ajax2.5b7696d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/ajax2.jpg
// module id = 67
// module chunks = 9